// CATALOGO DE VISTAS
export const CATALOGO_VISTAS = [
    "IZZI APPS",
    "MI CUENTA",
] as const;

// TIPOS POR VISTA
export const CATALOGO_TIPOS_POR_VISTA: Record<string, string[]> = {

    "IZZI APPS": [
        "BENEFICIOS",
        "INTERSECCION",
        "POPUP IZZI APPS",
        "ONBOARDING",
        "PAGINA BENEFICIOS",
        "IZZI TV+",
        "MI ENTRETENIMIENTO",
        "COMPLEMENTO",
        "ACTIVACION DE COMPLEMENTO",
        "INTERNET",
        "MOVIL",
        "TELEFONIA",
    ],

    "MI CUENTA": [
        "BENEFICIOS DESKTOP",
        "BENEFICIOS MOBILE",
        "POPUP MI CUENTA",
        "TEXTOS MARQUEE",
        "COMPLEMENTOS",
        "ACTIVACION CUENTA",
        "MI ENTRETENIMIENTO",
        "REDIMIR CERTIFICADO",
        "TELEFONIA",
        "ACTIVACION COMPLEMENTOS",
        "BANNER INFERIOR",
    ],

};

// CATALOGO DE SECCIONES
export const CATALOGO_SECCIONES = [
    "VIDEO",
    "IMAGEN",
    "TEXTO",
] as const;

// CATALOGO DE SECCIONES DE BANNER
export const CATALOGO_SECCION_BANNER = [
    "HOME",
    "UNIVERSAL",
    "VISTA_OFERTA",
    "BENEFICIOS",
] as const;


// CATALOGO DE TITULOS PARA TEXTOS MARQUEE
export const CATALOGO_TITULOS_MARQUEE = [
    "WARNING",
    "ERROR",
    "SUCCESS",
] as const;


// PIXELAJE POR VISTA Y TIPO
export const PIXELAJE_POR_VISTA_TIPO: Record<
    string,
    Record<string, string | null>
> = {

    "IZZI APPS": {
        "BENEFICIOS": "326x94",
        "INTERSECCION": "327x120",
        "POPUP IZZI APPS": "260x395",
        "ONBOARDING": "375x700",
        "PAGINA BENEFICIOS": "327x184",
        "IZZI TV+": "375x290",
        "MI ENTRETENIMIENTO": "375x290",
        "COMPLEMENTO": "375x192",
        "ACTIVACION DE COMPLEMENTO": "375x700",
        "INTERNET": "375x290",
        "MOVIL": "375x290",
        "TELEFONIA": "375x290",
    },

    "MI CUENTA": {
        "BENEFICIOS DESKTOP": "680x193",
        "BENEFICIOS MOBILE": "345x335",
        "POPUP MI CUENTA": "345x335",

        // No lleva información de pixelaje
        "TEXTOS MARQUEE": null,

        "COMPLEMENTOS": "345x335",
        "ACTIVACION CUENTA": "1130x240",
        "MI ENTRETENIMIENTO": "345x335",
        "REDIMIR CERTIFICADO": "876x315",
        "TELEFONIA": "876x315",
        "ACTIVACION COMPLEMENTOS": "968x366",
        "BANNER INFERIOR": "460x218",
    },
};

// CATALOGO TIPO DE VISTA

export const CATALOGO_TIPO_VISTA = [
    "CARRUSEL",
    "ESTATICO",
] as const;

// TOTAL DE POSICIONES PERMITIDAS
export const TOTAL_ORDENES_DISTRIBUCION = 5;

// CATALOGO DE ORDEN DE DISTRIBUCION
export const CATALOGO_ORDEN_DISTRIBUCION = Array.from(
  { length: TOTAL_ORDENES_DISTRIBUCION },
  (_, index) => index + 1
);